module.exports = __webpack_public_path__ + "static/media/bamboohr.28d89703.svg";